(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-collection-filter-close]');
    if (!closeButton) return;
    closeButton.closest('details')?.removeAttribute('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const closeDrawer = (header) => {
      if (!header) return;
      const drawer = header.querySelector('[data-search-drawer]');
      const opener = header.querySelector('[data-search-drawer-open]');
      header.classList.remove('search-drawer-active');
      document.body.classList.remove('search-drawer-open');
      drawer?.setAttribute('aria-hidden', 'true');
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    };

    const closeMegaMenus = (header, exceptItem) => {
      if (!header) return;
      header.querySelectorAll('.site-header__nav-item.is-open').forEach((item) => {
        if (item === exceptItem) return;
        item.classList.remove('is-open');
        item.querySelector('[data-mega-menu-trigger]')?.setAttribute('aria-expanded', 'false');
      });
    };

    document.addEventListener('click', (event) => {
      const mobileMenuCloser = event.target.closest('[data-mobile-menu-close]');
      if (mobileMenuCloser) {
        const mobileMenu = mobileMenuCloser.closest('.site-header__mobile-menu');
        if (mobileMenu) mobileMenu.open = false;
        mobileMenu?.querySelector(':scope > summary')?.focus();
        return;
      }

      const megaTrigger = event.target.closest('[data-mega-menu-trigger]');
      if (megaTrigger) {
        const item = megaTrigger.closest('.site-header__nav-item');
        const header = megaTrigger.closest('.site-header');
        const willOpen = !item?.classList.contains('is-open');
        closeMegaMenus(header, item);
        item?.classList.toggle('is-open', willOpen);
        megaTrigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      const opener = event.target.closest('[data-search-drawer-open]');
      if (opener) {
        const header = opener.closest('.site-header');
        const drawer = header?.querySelector('[data-search-drawer]');
        header?.classList.add('search-drawer-active');
        document.body.classList.add('search-drawer-open');
        drawer?.setAttribute('aria-hidden', 'false');
        opener.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => drawer?.querySelector('[data-search-drawer-input]')?.focus());
        return;
      }

      const closer = event.target.closest('[data-search-drawer-close]');
      if (closer) closeDrawer(closer.closest('.site-header'));

      const header = event.target.closest('.site-header');
      if (!event.target.closest('.site-header__nav-item--has-children')) closeMegaMenus(header || document.querySelector('.site-header'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const mobileMenu = document.querySelector('.site-header__mobile-menu[open]');
        if (mobileMenu) {
          event.preventDefault();
          mobileMenu.open = false;
          mobileMenu.querySelector(':scope > summary')?.focus();
          return;
        }
        const openTrigger = document.querySelector('.site-header__nav-item.is-open [data-mega-menu-trigger]');
        if (openTrigger) {
          closeMegaMenus(openTrigger.closest('.site-header'));
          openTrigger.focus();
        }
      }
      const header = document.querySelector('.site-header.search-drawer-active');
      if (!header) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer(header);
        return;
      }
      if (event.key !== 'Tab') return;
      const drawer = header.querySelector('[data-search-drawer]');
      const focusable = Array.from(drawer.querySelectorAll(focusableSelector)).filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
